import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {cpFormart, rfcFormat} from 'src/app/components/common/validations';
import {SessionService} from 'src/app/services/session.service';
import {PAISES_MUNDO} from '../../../../models/application/countriesWorld';
import {DeviceDetectorService} from 'ngx-device-detector';
import {DialogService} from '../../../../services/dialog.service';

@Component({
    selector: 'app-billing-info',
    templateUrl: './billing-info.component.html',
    styleUrls: ['./billing-info.component.scss']
})
export class BillingInfoComponent implements OnInit {
    @Input() active: boolean;
    acepptTerms = false;
    countries: any;
    form: FormGroup;
    formLatam: FormGroup;
    billingData: any;
    billingAdded: boolean;
    billingDataValid = false;
    addBilling = false;
    /* VARIABLES PARA SABER SI SON MOVILES */
    isMobile: any = false;
    isTablet: any = false;
    selected: any;

    constructor(
        private fb: FormBuilder,
        private sessionService: SessionService,
        private dialogService: DialogService,
        private deviceService: DeviceDetectorService
    ) {
        this.isMobile = this.deviceService.isMobile();
        this.isTablet = this.deviceService.isTablet();
        this.countries = PAISES_MUNDO.sort(
            (a, b) => {
                if (a.name_es > b.name_es) {
                    return 1;
                }
                if (a.name_es < b.name_es) {
                    return -1;
                }
                return 0;
            }
        );
        this.billingData = this.sessionService.getPaymentBilling();
        this.initForm();
    }

    ngOnInit(): void {
        if (this.sessionService.getPaymentBilling() != null && this.sessionService.getPaymentBilling() !== '') {
            this.billingData = this.sessionService.getPaymentBilling();
            this.form.setValue(this.billingData);
        } else {
            this.form.reset();
            this.sessionService.setPaymentBilling(this.form.getRawValue());
            this.billingData = this.sessionService.getPaymentBilling();
            this.refreshSteps();
        }

        /* LOCALIZACION */
        this.sessionService.getLocationUser().subscribe(
            (response: any) => {
                if (response) {
                    this.sessionService.getCountrieUser(response.location.lat, response.location.lng).subscribe(
                        (responseCountrie: any) => {
                            this.selected = PAISES_MUNDO.find(
                                country => country.code === this.getDatos(responseCountrie.results)
                            );
                            if (this.selected.code === 'MX') {
                                this.form.controls.country.setValue(this.selected.name_es);
                            } else {
                                this.formLatam.controls.country.setValue(this.selected.name_es);
                            }
                        }
                    );
                }
            }
        );
    }

    medataAdd(): void {
        if (!this.addBilling) {
            this.addBilling = true;
            this.sessionService.setPaymentBilling(null);
            this.billingData = this.sessionService.getPaymentBilling();
            this.billingAdded = null;
        } else {
            this.addBilling = false;
            if (this.sessionService.getCountryData()) {
                this.form.reset();
                this.sessionService.setPaymentBilling(this.form.getRawValue());
            } else {
                this.formLatam.reset();
                this.sessionService.setPaymentBilling(this.formLatam.getRawValue());
            }
            this.billingData = this.sessionService.getPaymentBilling();
            this.refreshSteps();
        }
    }

    initForm(): void {

        this.form = this.fb.group({
            country: [this.billingData?.country || '', Validators.compose([Validators.required])],
            state: [this.billingData?.state || '',
                Validators.compose([Validators.required, Validators.minLength(2), Validators.maxLength(50)])],
            city: [this.billingData?.city || '',
                Validators.compose([Validators.required, Validators.minLength(2), Validators.maxLength(50)])],
            code: [this.billingData?.code || '', Validators.compose([Validators.required, cpFormart,
                Validators.minLength(4), Validators.maxLength(8)])],
            address: [this.billingData?.address || '', Validators.compose([Validators.required,
                Validators.minLength(2), Validators.maxLength(50)])],
            rfc: [this.billingData?.rfc || '',
                Validators.compose([Validators.required, rfcFormat, Validators.minLength(10), Validators.maxLength(13)])],
            businessName: [this.billingData?.businessName || '', Validators.compose([Validators.required,
                Validators.minLength(2), Validators.maxLength(50)])],
            cfdiUses: ['', Validators.compose([Validators.required])]
        });

        this.formLatam = this.fb.group({
            country: [this.billingData?.country || '', Validators.compose([Validators.required])],
            state: [this.billingData?.state || '',
                Validators.compose([Validators.required, Validators.minLength(2), Validators.maxLength(50)])],
            city: [this.billingData?.city || '',
                Validators.compose([Validators.required, Validators.minLength(2), Validators.maxLength(50)])],
            code: [this.billingData?.code || '', Validators.compose([Validators.required,
                Validators.minLength(4), Validators.maxLength(8)])],
            address: [this.billingData?.address || '', Validators.compose([Validators.required,
                Validators.minLength(2), Validators.maxLength(50)])],
            rfc: [this.billingData?.rfc || '',
                Validators.compose([Validators.required, Validators.minLength(5)])],
            businessName: [this.billingData?.businessName || '', Validators.compose([Validators.required,
                Validators.minLength(2), Validators.maxLength(50)])],
            cfdiUses: ['']
        });

        this.formLatam.controls['code'].valueChanges.subscribe(
            r => {
                if (r.length >= 9) {
                    this.formLatam.controls['code'].setValue(r.substring(0, 8));
                }
            }
        );
    }

    saveData(): void {
        if (this.addBilling) {
            if (this.sessionService.getCountryData()) {
                if (this.form.valid) {
                    this.sessionService.setPaymentBilling(this.form.getRawValue());
                    this.billingData = this.sessionService.getPaymentBilling();
                    this.billingDataValid = true;
                    this.refreshSteps();
                } else {
                    this.dialogService.showNotificationDialog('Ups!', 'Todos los campos son requeridos.');
                }
            } else {
                if (this.formLatam.valid) {
                    this.sessionService.setPaymentBilling(this.formLatam.getRawValue());
                    this.billingData = this.sessionService.getPaymentBilling();
                    this.billingDataValid = true;
                    this.refreshSteps();
                } else {
                    this.dialogService.showNotificationDialog('Ups!', 'Todos los campos son requeridos.');
                }
            }
        } else {
            if (this.sessionService.getCountryData()) {
                this.sessionService.setPaymentBilling(this.form.getRawValue());
            } else {
                this.sessionService.setPaymentBilling(this.formLatam.getRawValue());
            }
            this.billingData = this.sessionService.getPaymentBilling();
            this.refreshSteps();
        }
        this.addDataLayer();
    }

    refreshSteps(): void {
        const steps = this.sessionService.getPaymentSteps();
        this.billingAdded = steps.billingStep.completed;
    }

    refreshEmpty(): void {
        const steps = this.sessionService.getPaymentSteps();
        this.billingAdded = steps.billingStep.completed = false;
        this.billingDataValid = false;
    }

    getDatos(paises: any): any {
        let mex = '';
        paises.forEach(
            pais => {
                pais.address_components.forEach(
                    address => {
                        const data = address.types.find(type => type === 'country');
                        if (data) {
                            mex = address.short_name;
                        }
                    }
                );
            }
        );
        return mex;
    }

    addDataLayer(): any {
        // @ts-ignore
        window.dataLayer = window.dataLayer || [];
        // @ts-ignore
        dataLayer.push({ecommerce: null});  // Clear the previous ecommerce object.
        // @ts-ignore
        dataLayer.push({
            event: 'checkout',
            ecommerce: {
                checkout: {
                    actionField: {step: 3, option: 'Información de Facturacion'},
                }
            }
        });
    }

}
